import type { SVGProps } from "react";

export type IconName =
  | "calendar"
  | "chevron"
  | "close"
  | "collapse"
  | "compass"
  | "drivers"
  | "expand"
  | "feedback"
  | "info"
  | "layers"
  | "map"
  | "search"
  | "standings"
  | "star"
  | "time";

const paths: Record<IconName, React.ReactNode> = {
  calendar: (
    <path d="M5 3v3m14-3v3M3.5 9h17M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
  ),
  chevron: <path d="m8 10 4 4 4-4" />,
  close: <path d="m7 7 10 10M17 7 7 17" />,
  collapse: (
    <>
      <path d="M5 8h14M5 16h14" />
      <path d="m9 11 3 3 3-3" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.5 8.5-2.1 4.9-4.9 2.1 2.1-4.9 4.9-2.1Z" />
    </>
  ),
  drivers: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 20v-2.4A4.6 4.6 0 0 1 8.1 13h1.8a4.6 4.6 0 0 1 4.6 4.6V20M16 5.5a3 3 0 0 1 0 5.8M17 14a4.6 4.6 0 0 1 3.5 4.5V20" />
    </>
  ),
  expand: (
    <>
      <path d="M8.5 3H3v5.5M15.5 3H21v5.5M8.5 21H3v-5.5M15.5 21H21v-5.5" />
      <path d="m8 8-5-5m13 5 5-5M8 16l-5 5m13-5 5 5" />
    </>
  ),
  feedback: (
    <>
      <path d="M4 4.5h16v11H9l-5 4v-15Z" />
      <path d="M8 9h8m-8 3h5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 10v7m0-10.5v.1" />
    </>
  ),
  layers: (
    <>
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m4.5 12 7.5 4 7.5-4M4.5 16l7.5 4 7.5-4" />
    </>
  ),
  map: (
    <>
      <path d="m3 6 5-3 8 3 5-3v15l-5 3-8-3-5 3V6Z" />
      <path d="M8 3v15m8-12v15" />
    </>
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m15.5 15.5 5 5" />
    </>
  ),
  standings: (
    <>
      <path d="M4 20V10h5v10m1.5 0V4h5v16M17 20v-7h3v7" />
      <path d="M2 20h20" />
    </>
  ),
  star: (
    <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z" />
  ),
  time: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
};

export function Icon({
  name,
  ...props
}: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
